import { useSetRoute } from '@features/app-hooks'
import { useOrganization } from '@features/organizations'
import { OrganizationRole } from '@st/sdk'
import { Banner } from '@st/theme'
import { useSelect } from '~/store'
import { selLowBalanceModel } from './organization-billing-module'

type Props = {
  role: OrganizationRole
}

export function OrganizationLowBalanceBanner({ role }: Props) {
  const setRoute = useSetRoute()
  const organization = useOrganization()
  const lowBalance = useSelect('organizationBilling', selLowBalanceModel)

  if (role == 'restricted' || !lowBalance) {
    return null
  }

  return (
    <Banner variant="error" className="rounded-none border-b border-stone-200">
      <p className="text-center">
        <span>{`Your credit balance is ${lowBalance.currentBalance}. Please `}</span>
        <button
          type="button"
          className="inline cursor-pointer appearance-none border-0 bg-transparent p-0 font-semibold text-white underline underline-offset-2 align-baseline hover:opacity-90"
          onClick={() =>
            setRoute({
              name: 'organization_balance',
              organizationSlug: organization.slug
            })
          }
        >
          purchase additional credits
        </button>
        <span> to continue using StanfordTax.</span>
      </p>
    </Banner>
  )
}
